"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterTypesTableLanguage = exports.filterTypesTable = exports.TableActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var TableActionTypes = (0, _namespacedKeyMirror.default)({
  FILTER_TYPES_TABLE: null,
  FILTER_TYPES_TABLE_LANGUAGE: null
}, 'email');
exports.TableActionTypes = TableActionTypes;
var filterTypesTable = (0, _fluxActions.createAction)(TableActionTypes.FILTER_TYPES_TABLE, (0, _actions.mapPayloadTo)('type'));
exports.filterTypesTable = filterTypesTable;
var filterTypesTableLanguage = (0, _fluxActions.createAction)(TableActionTypes.FILTER_TYPES_TABLE_LANGUAGE, (0, _actions.mapPayloadTo)('languageCode'));
exports.filterTypesTableLanguage = filterTypesTableLanguage;